module.exports = __webpack_public_path__ + "static/media/post-3.7dfcd362.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post-3.jpg
// module id = 1183
// module chunks = 33